// Gear Exchange API client
import client from './client';

export interface GXAssetResponse {
  list_item_id: string;
  filename: string;
  file_size: number;
  width: number;
  height: number;
  file_type: string;
  thumbnail_url: string;
  preview_url: string;
  folder_path: string;
  fordshare_id: string;
}

export interface GXSearchResponse {
  fordshare_id: string;
  total_assets: number;
  assets: GXAssetResponse[];
}

export interface GXMultiSearchResponse {
  fordshare_ids: string[];
  results: GXSearchResponse[];
  total_assets: number;
}

export async function searchGearExchange(campaignId: string): Promise<GXMultiSearchResponse> {
  const response = await client.get<GXMultiSearchResponse>(
    `/campaigns/${campaignId}/gear-exchange/assets`
  );
  return response.data;
}

export interface GXDownloadLink {
  list_item_id: string;
  download_url: string | null;
  error: string | null;
}

export interface GXDownloadResponse {
  links: GXDownloadLink[];
}

export async function getGXDownloadLinks(
  campaignId: string,
  listItemIds: string[],
): Promise<GXDownloadResponse> {
  const response = await client.post<GXDownloadResponse>(
    `/campaigns/${campaignId}/gear-exchange/download-links`,
    { list_item_ids: listItemIds },
  );
  return response.data;
}
